var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6875 3.01562H12.2031C10.9364 3.01562 9.90625 4.04577 9.90625 5.3125V9.90625H5.3125C4.04577 9.90625 3.01562 10.9364 3.01562 12.2031V23.6875C3.01562 24.9542 4.04577 25.9844 5.3125 25.9844H16.7969C18.0636 25.9844 19.0938 24.9542 19.0938 23.6875V19.0938H23.6875C24.9542 19.0938 25.9844 18.0636 25.9844 16.7969V5.3125C25.9844 4.04577 24.9542 3.01562 23.6875 3.01562ZM5.3125 23.6875V12.2031H16.7969L16.7992 23.6875H5.3125ZM23.6875 16.7969H19.0938V12.2031C19.0938 10.9364 18.0636 9.90625 16.7969 9.90625H12.2031V5.3125H23.6875V16.7969Z",
    fill: "#2795AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60938 14.5H14.5V16.7969H7.60938V14.5ZM7.60938 19.0938H14.5V21.3906H7.60938V19.0938Z",
    fill: "#2795AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCourses);
export default __webpack_public_path__ + "static/media/total-courses.b560337a65e635197bca17ee13d5116e.svg";
export { ForwardRef as ReactComponent };